import {TSModulTagesschuleGroup} from '../TSModulTagesschuleGroup';

export class TSModulTagesschuleGroupHasAnmeldung extends TSModulTagesschuleGroup {
    hasAnmeldung: boolean = false;
}
